var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.833,
    height: 14,
    viewBox: "0 0 12.833 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M9.474.375V1.656H1.363v8.906H0V1.656A1.2,1.2,0,0,1,.4.747,1.357,1.357,0,0,1,1.363.375ZM11.5,2.937a1.318,1.318,0,0,1,.935.373,1.17,1.17,0,0,1,.4.879v8.906a1.2,1.2,0,0,1-.4.909,1.318,1.318,0,0,1-.935.372H4.056A1.359,1.359,0,0,1,3.089,14a1.2,1.2,0,0,1-.4-.908V4.188a1.167,1.167,0,0,1,.4-.879,1.361,1.361,0,0,1,.966-.373H11.5Zm0,10.157V4.188H4.056v8.906H11.5Z",
    transform: "translate(0 -0.375)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.690c1b0923c2a4e65d91ef271171e127.svg";